import {MessageDescriptor} from '@lingui/core';
import {t} from '@lingui/macro';

/*
 * Types.
 */

export enum RequiredTaggingEditorBaseErrorsEnum {
  NO_TAG_LIST = 'NO_TAG_LIST',
  MISSING_TAG_LIST_NAME = 'MISSING_TAG_LIST_NAME',
  TAG_LIST_NAME_CONFLICT = 'TAG_LIST_NAME_CONFLICT',
  // TODO: legacy, remove
  INVALID_TAG_LIST = 'INVALID_TAG_LIST',
}

/*
 * Constants.
 */

export const requiredTaggingEditorBaseErrorLabels: Record<
  RequiredTaggingEditorBaseErrorsEnum,
  MessageDescriptor
> = {
  [RequiredTaggingEditorBaseErrorsEnum.NO_TAG_LIST]: t(
    'required-tagging-editor-card-error-missing-tag-list',
  )`Tag list is required`,
  [RequiredTaggingEditorBaseErrorsEnum.MISSING_TAG_LIST_NAME]: t(
    'required-tagging-editor-card-error-missing-name',
  )`Missing tag list name`,
  [RequiredTaggingEditorBaseErrorsEnum.TAG_LIST_NAME_CONFLICT]: t(
    'required-tagging-editor-tag-list-name-conflict',
  )`This tag list already exists`,
  [RequiredTaggingEditorBaseErrorsEnum.INVALID_TAG_LIST]: t(
    'required-tagging-editor-footer-tooltip-warning-invalid-tag-list',
  )`Some of your tag lists are invalid`,
};
